import type { MaskitoPreprocessor } from "@maskito/core"
import { numberToWords } from "@persian-tools/persian-tools"
import moment from "jalali-moment"
import { parse, stringify } from "picoquery"

export function toQuery(input: Record<string, any>) {
	return stringify(input)
}

export function fromQuery(input: string) {
	return parse(input, { valueDeserializer: decoder })
}

export function readNumber(number: string | number) {
	const stringNumber = typeof number === "number" ? number.toString() : number
	return numberToWords(stringNumber)
}

export function toEnglish(value: string | number): string {
	const persianToEnglishMap: Record<string, string | undefined> = {
		"۰": "0",
		"۱": "1",
		"۲": "2",
		"۳": "3",
		"۴": "4",
		"۵": "5",
		"۶": "6",
		"۷": "7",
		"۸": "8",
		"۹": "9",
	}

	const valueString = value.toString()

	return valueString
		.split("")
		.map(char => persianToEnglishMap[char] ?? char)
		.join("")
}

export const toEnglishProcessor: MaskitoPreprocessor = ({ elementState, data }) => {
	const { value, selection } = elementState

	return {
		elementState: {
			selection,
			value: toEnglish(value),
		},
		data: toEnglish(data),
	}
}

export function scrollBottom() {
	if (import.meta.client)
		window.scrollTo({ behavior: "smooth", top: document.body.scrollHeight })
}

function decoder(str: string) {
	// Handle boolean values
	if (str === "true")
		return true

	if (str === "false")
		return false

	// Handle empty string
	if (str === "")
		return null

	// Handle numbers
	if (!Number.isNaN(Number(str)) && str.trim() !== "") {
		return Number(str)
	}

	// Default case: return the string as is
	return str
}

export function formatRelativeTime(dateTime: string) {
	const momentObj = moment(dateTime)
	const now = moment()

	const diffInDays = now.diff(momentObj, "days")
	const diffInHours = now.diff(momentObj, "hours")
	const diffInMinutes = now.diff(momentObj, "minutes")

	if (diffInDays >= 1) {
		return `${diffInDays} روز پیش`
	}
	else if (diffInHours >= 1) {
		return `${diffInHours} ساعت پیش`
	}
	else if (diffInMinutes >= 1) {
		return `${diffInMinutes} دقیقه پیش`
	}
	else {
		return "یک دقیقه پیش"
	}
}
